import React from 'react'
import { Document } from './components/document'
import { LearnMore } from './components/learnmore';
import { Split } from './components/split';
import './values.css';

export class Values extends React.Component {

    render() {
        return (
            <>
            <Split>
                <Document>
                    <h2>Who are "we" exactly?</h2>
                    <div className="team-content">
                        <div className="team-text">
                            <p>
                                Tigercity.ai is an early-stage AI startup focused on making custom LLM training accessible to non-technical users. 
                                The company was founded by Erlend Grønnevet, who holds a Master's degree in AI from NTNU and has spent the past 2.5 years building the platform from the ground up. 
                                With more than four decades of software development experience, Erlend combines deep technical expertise with a strong focus on product usability and practical AI adoption.
                            </p>
                            <p>
                                Recently, Sithumya Jayawardhana joined the team after graduating in software engineering, bringing fresh energy and helping accelerate development of the platform. 
                                Together, we're working to make AI training and private deployment accessible to everyone, not just organizations with dedicated AI teams.
                            </p>
                            <LearnMore to="/docs/founder">About the founder</LearnMore>
                        </div>
                        <div className="images">
                            <div className="erl">
                                <img src="./erlend.png" alt="" />
                                <p>Erlend Grønnevet</p>
                            </div>
                            <div className="sith">
                                <img src="/images/sithumya.jpg" alt="" />
                                <p>Sithumya Jayawardhana</p>
                            </div>
                        </div>
                    </div>
                </Document>
            </Split>

            <div style={{ paddingBottom: "2rem" }} />

            <Document>
                <h2>Values? TLDR: We love AI, hate the hype</h2>
                <p>We’re a Norwegian company, which means democracy, human rights, and truth are non‑negotiable.</p>
                <p>We love AI, but we hate the hype. The industry is full of inflated claims and magic promises that mislead customers and frustrate developers. That’s why we commit to radical honesty about what our models can and cannot do. We’ll never oversell or mislead—only give the straight truth about capabilities, limitations, and realistic expectations.</p>
                <p>This approach helps our customers plan with clarity and build solutions that deliver real value to real people, instead of wasting resources on empty hype.</p>
                <p>We also believe in supporting open‑source solutions, because transparency and shared innovation make AI safer, stronger, and more accessible. And we stand firmly by free competition, because progress comes from healthy markets where the best ideas—not monopolies—win.</p>
                <p>Most importantly, we respect your privacy. You retain complete ownership of your data, intellectual property, and trained models. We will never claim ownership over your work or use your data in ways you haven’t explicitly agreed to.</p>
                <p>This is the Norwegian approach to business: direct, honest, and focused on long‑term relationships over short‑term profits. It’s also exactly what the AI industry needs right now.</p>
            </Document>
            </>
        );
    }
}
